import React, {Component } from 'react';
import {Button} from "reactstrap";
import {connect} from "react-redux";
import ContainerDimensions from "react-container-dimensions";
import {Group, Layer, Rect, Stage, Text, Transformer} from "react-konva";
import Tour from 'reactour';
import CachedImage from "../CachedImage";
import {moveFinalImage, setPhase, removeFaceFinalImage, closeTour} from "../../actions";

class FacePositionCanvas extends Component {
  trRef = null;
  grRef = null;

  state = {
    selected: true
  }

  constructor(props) {
    super(props);
    this.renderImage = this.renderImage.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleStageClick = this.handleStageClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.selected === this.state.selected) {
      return;
    }

    if (this.state.selected) {
      this.trRef.nodes([this.grRef]);
      this.trRef.forceUpdate();
      this.trRef.getLayer().batchDraw();
    } else {
      this.trRef.detach(this.grRef);
      this.trRef.getLayer().batchDraw();
    }
  }

  componentDidMount() {
    if (this.state.selected) {
      this.trRef.nodes([this.grRef]);
      this.trRef.forceUpdate();
      this.trRef.getLayer().batchDraw();
    } else {
      this.trRef.detach(this.grRef);
      this.trRef.getLayer().batchDraw();
    }
  }

  handleClick(e) {
    this.setState({selected: true});
    e.cancelBubble = true;
  }

  handleStageClick() {
    this.setState({selected: false});
  }

  render() {
    const { width, height } = this.props;
    const paperX = 550;
    const paperY = 910 * 1.1;
    const ratio = paperX / paperY;

    //const ratio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;
    const baseMaxHeight = Math.min(height - 10, paperY);
    const baseMaxWidth = baseMaxHeight * ratio;
    const positionRatio = paperY / baseMaxHeight;
    const leftRatio = paperX / baseMaxWidth;
    const canvasWidth = width - 20;
    const leftPos = (canvasWidth - baseMaxWidth) / 2;
    const sizeRatio = baseMaxHeight / paperY;

    const imageRatio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;
    const imageProps = {
      id: 'face',
      ...this.props.meishi.finalImage,
      props: {
        width: baseMaxWidth,
        height: baseMaxWidth / imageRatio,
        x: this.props.meishi.finalImage.x / leftRatio,
        y: this.props.meishi.finalImage.y / positionRatio,
        scaleX: this.props.meishi.finalImage.scaleX,
        scaleY: this.props.meishi.finalImage.scaleY,
      }
    }

    const currentLayout = this.props.meishi.layouts[this.props.meishi.currentLayout];

    return (
      <React.Fragment>
        <Stage width={canvasWidth} height={baseMaxHeight} style={{backgroundColor: "transparent"}} onClick={this.handleStageClick}>
          <Layer clip={{x: leftPos, y: 0, width: baseMaxWidth, height: baseMaxHeight}}>
            <Rect x={leftPos} width={baseMaxWidth} height={baseMaxHeight} fill={"#fff"}/>
            <Group
              ref={ref => {this.grRef = ref;}}
              x={imageProps.props.x + leftPos} y={imageProps.props.y}
              draggable={true}
              onClick={this.handleClick}
              onTransformEnd={(e) => {
                //console.log(e.target.attrs);
                this.props.moveFinalImage({
                  x: (e.target.attrs.x - leftPos) * leftRatio,
                  y: e.target.attrs.y * positionRatio,
                  scaleX: e.target.attrs.scaleX,
                  scaleY: e.target.attrs.scaleY,
                });
              }}
              onDragEnd={(e) => {
                //console.log(e.target.attrs, e.target.attrs.y * positionRatio);
                this.props.moveFinalImage({
                  x: (e.target.attrs.x - leftPos) * leftRatio,
                  y: e.target.attrs.y * positionRatio,
                  scaleX: this.props.meishi.finalImage.scaleX,
                  scaleY: this.props.meishi.finalImage.scaleY,
                });
              }}
              scaleX={this.props.meishi.finalImage.scaleX}
              scaleY={this.props.meishi.finalImage.scaleY}
            >
              {this.renderImage(imageProps, positionRatio)}
            </Group>
            {/*<Transformer ref={ref => {this.trRef = ref;}} />*/}
          </Layer>
          <Layer x={(canvasWidth - baseMaxWidth) / 2} y={0} listening={false}>
            <Rect x={0} y={0} height={baseMaxHeight * 0.1} width={baseMaxWidth} fill="#000000" opacity={0.5} />
            {currentLayout.objects.map((object, i) => {
              const font = this.props.meishi.textFonts[object.id] || this.props.fonts.fonts[0];
              const color = this.props.meishi.textColors[object.id] || '#000000';
              const text = this.props.meishi.textValues[object.id];

              if (text) {
                return <Text
                  key={i}
                  x={object.x * baseMaxWidth}
                  y={object.y * baseMaxHeight}
                  fontSize={object.fontSize * sizeRatio}
                  text={this.props.meishi.textValues[object.id]}
                  fontFamily={font.value}
                  fill={color}
                />;
              } else {
                return <Text
                  key={i}
                  x={object.x * baseMaxWidth}
                  y={object.y * baseMaxHeight}
                  fontSize={object.fontSize * sizeRatio}
                  text={object.sample}
                  fontFamily={font.value}
                  fill={'#cccccc'}
                />;
              }


            })}
          </Layer>
          <Layer>
            <Transformer ref={ref => {this.trRef = ref;}} keepRatio={true} enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']} />
          </Layer>

        </Stage>
      </React.Fragment>
    );
  }

  renderImage(object, ratio) {
    return (
      <CachedImage
        name={object.id} src={object.src} props={{...object.props, x: 0, y: 0, scaleX: 1, scaleY: 1}}
        draggable={false} inline={true}
      />
    );
  }
}

FacePositionCanvas = connect(f => f, {moveFinalImage})(FacePositionCanvas);

class FacePosition extends Component {

  // trRef = null;
  // grRef = null;

  state = {
    isTourOpen: true,
    // selected: true
  }

  constructor(props) {
    super(props);
    this.renderImage = this.renderImage.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    // this.handleClick = this.handleClick.bind(this);
    // this.handleStageClick = this.handleStageClick.bind(this);
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (prevState.selected === this.state.selected) {
  //     return;
  //   }
  //
  //   if (this.state.selected) {
  //     this.trRef.nodes([this.grRef]);
  //     this.trRef.forceUpdate();
  //     this.trRef.getLayer().batchDraw();
  //   } else {
  //     this.trRef.detach(this.grRef);
  //     this.trRef.getLayer().batchDraw();
  //   }
  // }
  //
  // componentDidMount() {
  //   if (this.state.selected) {
  //     this.trRef.nodes([this.grRef]);
  //     this.trRef.forceUpdate();
  //     this.trRef.getLayer().batchDraw();
  //   } else {
  //     this.trRef.detach(this.grRef);
  //     this.trRef.getLayer().batchDraw();
  //   }
  // }

  // handleClick(e) {
  //   this.setState({selected: true});
  //   e.cancelBubble = true;
  // }
  //
  // handleStageClick() {
  //   this.setState({selected: false});
  // }

  handleBack() {
    this.props.removeFaceFinalImage();
  }

  handleNext() {
    this.props.setPhase(2);
  }

  render() {
    return (
      <React.Fragment>
        <div className="t-container-canvas">
          <div className="t-content-right-toolbar">
            <div className="actions">
              <Button onClick={this.handleBack}>前へ: 顎ラインのトリミング</Button>
              <Button color="info" onClick={this.handleNext}>次へ: テキストの入力</Button>
            </div>
            <div>名刺に印刷する位置を調整してください</div>
          </div>
          <div className="t-canvas-container">
            {/*<Layers />*/}
            <div id="t-canvas-container-inside" className="t-canvas-container-inside">
              <ContainerDimensions>
                <FacePositionCanvas />
                {/*{({width, height}) => {*/}
                {/*  // let scale = 1.0;*/}
                {/*  const paperX = 610 * 1.1;*/}
                {/*  const paperY = 970;*/}
                {/*  const ratio = paperX / paperY;*/}

                {/*  //const ratio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;*/}
                {/*  const baseMaxHeight = Math.min(height - 10, paperY);*/}
                {/*  const baseMaxWidth = baseMaxHeight * ratio;*/}
                {/*  const positionRatio = paperY / baseMaxHeight;*/}
                {/*  const leftRatio = paperX / baseMaxWidth;*/}
                {/*  const canvasWidth = width - 20;*/}
                {/*  const leftPos = (canvasWidth - baseMaxWidth) / 2;*/}

                {/*  const imageRatio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;*/}
                {/*  const imageProps = {*/}
                {/*    id: 'face',*/}
                {/*    ...this.props.meishi.finalImage,*/}
                {/*    props: {*/}
                {/*      width: baseMaxWidth,*/}
                {/*      height: baseMaxWidth / imageRatio,*/}
                {/*      x: this.props.meishi.finalImage.x / leftRatio,*/}
                {/*      y: this.props.meishi.finalImage.y / positionRatio,*/}
                {/*      scaleX: this.props.meishi.finalImage.scaleX,*/}
                {/*      scaleY: this.props.meishi.finalImage.scaleY,*/}
                {/*    }*/}
                {/*  }*/}

                {/*  return (*/}
                {/*    <React.Fragment>*/}
                {/*      <Stage width={canvasWidth} height={baseMaxHeight} style={{backgroundColor: "transparent"}} onClick={this.handleStageClick}>*/}
                {/*        <Layer clip={{x: leftPos, y: 0, width: baseMaxWidth, height: baseMaxHeight}}>*/}
                {/*          <Rect x={leftPos} width={baseMaxWidth} height={baseMaxHeight} fill={"#fff"}/>*/}
                {/*          <Group*/}
                {/*            ref={ref => {this.grRef = ref;}}*/}
                {/*            x={imageProps.props.x + leftPos} y={imageProps.props.y}*/}
                {/*            draggable={true}*/}
                {/*            onClick={this.handleClick}*/}
                {/*            onTransformEnd={(e) => {*/}
                {/*              //console.log(e.target.attrs);*/}
                {/*              this.props.moveFinalImage({*/}
                {/*                x: (e.target.attrs.x - leftPos) * leftRatio,*/}
                {/*                y: e.target.attrs.y * positionRatio,*/}
                {/*                scaleX: e.target.attrs.scaleX,*/}
                {/*                scaleY: e.target.attrs.scaleY,*/}
                {/*              });*/}
                {/*            }}*/}
                {/*            onDragEnd={(e) => {*/}
                {/*              //console.log(e.target.attrs, e.target.attrs.y * positionRatio);*/}
                {/*              this.props.moveFinalImage({*/}
                {/*                x: (e.target.attrs.x - leftPos) * leftRatio,*/}
                {/*                y: e.target.attrs.y * positionRatio,*/}
                {/*                scaleX: this.props.meishi.finalImage.scaleX,*/}
                {/*                scaleY: this.props.meishi.finalImage.scaleY,*/}
                {/*              });*/}
                {/*            }}*/}
                {/*            scaleX={this.props.meishi.finalImage.scaleX}*/}
                {/*            scaleY={this.props.meishi.finalImage.scaleY}*/}
                {/*          >*/}
                {/*            {this.renderImage(imageProps, positionRatio)}*/}
                {/*          </Group>*/}
                {/*          /!*<Transformer ref={ref => {this.trRef = ref;}} />*!/*/}
                {/*        </Layer>*/}
                {/*        <Layer x={(canvasWidth - baseMaxWidth) / 2} y={0} listening={false}>*/}
                {/*          <Rect x={0} y={0} height={baseMaxHeight * 0.1} width={baseMaxWidth} fill="#000000" opacity={0.5} />*/}
                {/*        </Layer>*/}
                {/*        <Layer>*/}
                {/*          <Transformer ref={ref => {this.trRef = ref;}} />*/}
                {/*        </Layer>*/}

                {/*      </Stage>*/}
                {/*    </React.Fragment>*/}
                {/*  )*/}
                {/*}}*/}
              </ContainerDimensions>
              {/*<KeyHandler keyCode={46} onKeyHandle={this.handleDeleteKeyDown}/>*/}
              {/*<KeyHandler keyCode={8} onKeyHandle={this.handleDeleteKeyDown}/>*/}
              {/*<KeyHandler keyCode={39} onKeyHandle={this.handleKeyMoveHOC({x: 1, y: 0})}/>*/}
              {/*<KeyHandler keyCode={37} onKeyHandle={this.handleKeyMoveHOC({x: -1, y: 0})}/>*/}
              {/*<KeyHandler keyCode={38} onKeyHandle={this.handleKeyMoveHOC({x: 0, y: -1})}/>*/}
              {/*<KeyHandler keyCode={40} onKeyHandle={this.handleKeyMoveHOC({x: 0, y: 1})}/>*/}
            </div>
            {/*<div className="t-canvas-container-aside">*/}
            {/*  <div className="aside-desc">*/}
            {/*    <div style={{background: '#CCC', marginBottom: '10px', padding: '10px'}}>*/}
            {/*      グレーの部分は塗り足し領域です。*/}
            {/*    </div>*/}
            {/*    <p>*/}
            {/*      お顔の写真はグレーの部分いっぱいまで配置してください。<br />*/}
            {/*      実際に表示される部分はグレー部分より下の範囲となります。*/}
            {/*    </p>*/}
            {/*  </div>*/}

            {/*</div>*/}
          </div>
        </div>
        {/*<Tour*/}
        {/*  steps={*/}
        {/*    [{*/}
        {/*      selector: '.t-canvas-container-inside',*/}
        {/*      content: () => (*/}
        {/*        <div>*/}
        {/*          <p>グレーの部分は塗り足し領域です。グレーの部分いっぱいまで画像を配置してください。<br />実際に印刷されるのはグレーを除く部分です。</p>*/}
        {/*          <p>写真をクリックするとサイズ変更ができます。マウスでドラッグして位置調整を行ってください。</p>*/}
        {/*          <img src={window.tProjectGlobals.assetBaseUrl + "img/tour-pic2.png"} alt="" style={{width:'100%'}}/>*/}
        {/*        </div>*/}
        {/*      )*/}
        {/*    }]*/}
        {/*  }*/}
        {/*  isOpen={this.props.meishi.tour[3]}*/}
        {/*  onRequestClose={() => { this.props.closeTour(3) }}*/}
        {/*  showNumber={false}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }

  renderImage(object, ratio) {
    return (
      <CachedImage
        name={object.id} src={object.src} props={{...object.props, x: 0, y: 0, scaleX: 1, scaleY: 1}}
        draggable={false} inline={true}
      />
    );
  }
}

export default connect(f => f, {moveFinalImage, setPhase, removeFaceFinalImage, closeTour})(FacePosition);


// WEBPACK FOOTER //
// ./src/components/Face/FacePosition.js